import React from 'react';
import { AppIcon } from './AppIcon';

/** Pre-built icons for AppHeader / Header toolbar buttons. */
export const HeaderIcons = {
  back: <AppIcon name="arrowBack" />,
  home: <AppIcon name="home" />,
  refresh: <AppIcon name="refresh" />,
} as const;
